import classNames from 'classnames';
import { t } from 'ttag';

import { PaymentMethodEnum } from '@newModels';
import ReturnIcon from '@svg/return.svg';
import { Image } from '@ui/Image';
import { Link } from '@ui/Link';

import s from './ProductDetailsSellerMethods.sss';

interface DeliverySetting {
  name: string,
  icon: string,
  description: string,
  minTariff?: string,
}

interface PaymentMethod {
  id: PaymentMethodEnum,
  name: string,
  isEnabled: boolean,
  isHidden: boolean,
  icon: string,
}

interface Props {
  className?: string,
  deliverySettings?: DeliverySetting[] | null,
  paymentMethods?: PaymentMethod[] | null,
  isReturnEnabled?: boolean | null,
}

export const ProductDetailsSellerMethods: React.FC<Props> = ({
  className,
  deliverySettings,
  paymentMethods,
  isReturnEnabled,
}) => {
  return (
    <ul className={classNames(s.row, className)}>
      {!!deliverySettings?.length && (
        <li className={s.column}>
          <p className={s.title}>
            {t`Способи доставки:`}
          </p>

          <ul className={s.list}>
            {deliverySettings.map((setting) => {
              return (
                <li
                  key={setting.name}
                  className={s.item}
                >
                  <Image
                    className={s.icon}
                    src={setting.icon}
                    width='24'
                    height='24'
                    lazy={true}
                  />

                  <p className={s.name}>
                    {setting.name}
                    &nbsp;
                    <span className={s.description}>
                      {setting.minTariff}
                    </span>
                  </p>
                </li>
              );
            })}
          </ul>
        </li>
      )}

      {!!paymentMethods?.length && (
        <li className={s.column}>
          <p className={s.title}>
            {t`Способи оплати:`}
          </p>

          <ul className={s.list}>
            {paymentMethods.filter((method) => method.isEnabled).map((method) => {
              return (
                <li
                  key={method.name}
                  className={s.item}
                >
                  <Image
                    className={s.icon}
                    src={method.icon}
                    width='24'
                    height='24'
                    lazy={true}
                  />

                  <p className={s.name}>
                    {method.name}
                  </p>
                </li>
              );
            })}
          </ul>
        </li>
      )}

      <li className={s.column}>
        <p className={s.title}>
          {t`Повернення:`}
        </p>

        <ul className={s.list}>
          <li className={s.item}>
            <ReturnIcon
              className={s.icon}
              width='24'
              height='24'
            />

            {isReturnEnabled ? (
              <Link
                className={s.name}
                theme='black'
                href="https://shafa.ua/page/usloviya-vozvrata-tovara"
              >
                {t`Протягом 14 днів після отримання товару`}
              </Link>
            ) : (
              <span className={s.name}>
                {t`Товар не підлягає поверненню`}
              </span>
            )}
          </li>
        </ul>
      </li>
    </ul>
  );
};
